import localforage from 'localforage'

// localforage.setDriver(localforage.INDEXEDDB)
// localforage.setDriver(localforage.LOCALSTORAGE);
localforage.config({
  driver: [localforage.LOCALSTORAGE, localforage.INDEXEDDB],
  name: 'zero-dark-web',
  // storeName: 'zero-dark-web',
})

export default localforage
